import Script from "next/script";
import { GTM_SCRIPT_ID, ZENDESK_KEY } from "@constants/env-variables";

import { gtmScript } from "@stadium/services/google-tag-manager";
import { SCRIPT_SRC, getDefaultSettings } from "@stadium/services/zendesk";

const GlobalScripts = () => {
  const zendeskScriptSrc = `${SCRIPT_SRC}?key=${ZENDESK_KEY}`;
  /* ToDo: Zendesk fetches a ton of files and it might cause main thread blocking resulting in
     poor lighthouse scores
  */
  return (
    <>
      {/* Google Tag Manager */}
      <Script text="text/javascript" strategy="lazyload" id="gtm">
        {gtmScript(GTM_SCRIPT_ID)}
      </Script>
      {/* End Google Tag Manager */}
      {/* Zendesk Chat */}
      <Script id="zendesk-settings" strategy="afterInteractive">
        {getDefaultSettings()}
      </Script>
      <Script id="ze-snippet" src={zendeskScriptSrc} strategy="afterInteractive" />
      {/* End Zendesk Chat */}
    </>
  );
};

export default GlobalScripts;
